import script from "./NumberFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberFilter.vue?vue&type=script&setup=true&lang=js"

import "./NumberFilter.vue?vue&type=style&index=0&id=6f74bc2c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f74bc2c"]])

export default __exports__